import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {authUserManager} from "../helpers/api_helper";

const Navdata = () => {
  const history = useNavigate();
  const eventId = authUserManager.getAuthUser().eventId;
  //state data
  const [isDashboard, setIsDashboard] = useState(false);

  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }
  }, [
    history,
    iscurrentState,
    isDashboard,
  ]);

  const menuItems = [
    {
      label: "Menu",
      isHeader: true,
    },
    {
      id: "dashboard",
      label: "Dashboards",
      icon: "ri-dashboard-2-line",
      link: "/#",
      stateVariables: isDashboard,
      click: function (e) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
        updateIconSidebar(e);
      },
      subItems: [
        ...(authUserManager.isAdmin() ? [{
          id: "users",
          label: "Users",
          link: "/admin/user",
          parentId: "dashboard",
        }] : []),
        {
          id: "event",
          label: "Event",
          link: "/admin/event/" + eventId,
          parentId: "dashboard",
        },
      ],
    }
  ];
  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
